/** Ecology is a planar ring; terrain may rotate about a separate tilted axis. */
export const SURFACE_CELL_COUNT = 32;
export function surfaceCoordinate(angle: number, spin: number): number {
  const turns = (angle - spin) / (Math.PI * 2);
  return (turns - Math.floor(turns)) * SURFACE_CELL_COUNT;
}
export function surfaceCellForAngle(angle: number, spin: number): number {
  return Math.min(SURFACE_CELL_COUNT - 1, Math.floor(surfaceCoordinate(angle, spin)));
}

// Same projected azimuth and spin convention. Shift half a cell so sampling
// a cell center returns that cell exactly, while its boundaries interpolate.
export const SURFACE_COORDINATE_GLSL = `
float surfaceVegetationCoordinate(vec2 projectedPosition, float spin) {
  float angle = dot(projectedPosition, projectedPosition) > 0.000000000001
    ? atan(projectedPosition.y, projectedPosition.x) : 0.0;
  return fract((angle - spin) / 6.28318530718 - 0.5 / ${SURFACE_CELL_COUNT}.0) * ${SURFACE_CELL_COUNT}.0;
}
`;
